const isServer = typeof window === 'undefined';

module.exports = {
  'development': {
    AURORA_API_PATH: 'http://localhost:12345/api/',
    REDIRECT_PROXY: 'http://localhost:12345/',
    SOLARIS_API_PATH: '',
    SOLARIS_API_PUBLIC_PATH: '',
    DISCOVER_API_PATH: '',
    DISCOVER_API_KEY: '',
    WS_URL: 'wss://localhost/',
    IMG_PATH: 'https://images.hu-staging.be',
    CDN_PATH: 'https://assets.hu-staging.be',
    ASSET_PREFIX_PATH: '',
    environment: 'development',
    gaTrackingId: '',
    gaTrackingDomain: '',
    ga4TrackingId: '',
    COOKIE_CONTROL_API_KEY: 'a8f76ffb6fddeedd010a170c4069c28c297c2f01',
  },
  'development-staging': {
    USE_DEV_PROXY: true,
    AURORA_API_PATH: isServer ? 'https://hu-staging.be/api/' : '/api/',
    REDIRECT_PROXY: 'https://hu-staging.be/',
    SOLARIS_API_PATH: isServer ? 'https://solaris-api.hu-staging.be/' : '/solaris-api/',
    SOLARIS_API_PUBLIC_PATH: isServer ? 'https://solaris-api.hu-staging.be/' : '/solaris-api/',
    DISCOVER_API_PATH: 'https://discover-api.hu-staging.be/',
    DISCOVER_API_KEY: 'API-KEY nCCzNRytj@x2urV4&hfNyD,Fji9RwwpW',
    WS_URL: 'wss://hu-staging.be/',
    IMG_PATH: 'https://images.hu-staging.be',
    CDN_PATH: 'https://assets.hu-staging.be',
    ASSET_PREFIX_PATH: '',
    environment: 'development',
    gaTrackingId: '', // UA-11066411-23 Betelgeuse Staging to debug locally
    gaTrackingDomain: '',
    ga4TrackingId: '', // G-8KMT47NK58 for G4 Betelgeuse Staging to debug locally
    COOKIE_CONTROL_API_KEY: 'a8f76ffb6fddeedd010a170c4069c28c297c2f01',
  },
  'development-production': {
    USE_DEV_PROXY: true,
    AURORA_API_PATH: isServer ? 'https://healthunlocked.com/api/' : '/api/',
    REDIRECT_PROXY: 'https://healthunlocked.com/',
    SOLARIS_API_PATH: isServer ? 'https://solaris.healthunlocked.com/' : '/solaris-api/',
    SOLARIS_API_PUBLIC_PATH: isServer ? 'https://solaris.healthunlocked.com/' : '/solaris-api/',
    DISCOVER_API_PATH: 'https://discover-api.hu-production.be/',
    DISCOVER_API_KEY: 'API-KEY [v4HVwTUCcccowGpcJqTddQsC3+/3BTs',
    WS_URL: 'wss://healthunlocked.com/',
    IMG_PATH: 'https://images.hu-production.be',
    CDN_PATH: 'https://assets.hu-production.be',
    ASSET_PREFIX_PATH: '',
    environment: 'development',
    gaTrackingId: '',
    gaTrackingDomain: '',
    ga4TrackingId: '',
    COOKIE_CONTROL_API_KEY: '21ad29290cdd60a97ce05df1864167a9764044e4',
  },
  'staging': {
    AURORA_API_PATH: isServer ? 'http://hu-nginx-internal.staging.hu-internal.be/api/' : 'https://hu-staging.be/api/',
    REDIRECT_PROXY: 'https://hu-staging.be/',
    SOLARIS_API_PATH: isServer ? 'http://hu-nginx-internal.staging.hu-internal.be/' : 'https://hu-staging.be/',
    SOLARIS_API_PUBLIC_PATH: isServer ? 'http://solaris-api.staging.hu-internal.be/' : 'https://solaris-api.hu-staging.be/',
    DISCOVER_API_PATH: 'https://discover-api.hu-staging.be/',
    DISCOVER_API_KEY: 'API-KEY nCCzNRytj@x2urV4&hfNyD,Fji9RwwpW',
    WS_URL: 'wss://hu-staging.be/',
    IMG_PATH: 'https://images.hu-staging.be',
    CDN_PATH: 'https://assets.hu-staging.be',
    ASSET_PREFIX_PATH: 'https://assets.hu-staging.be/solaris',
    environment: 'staging',
    gaTrackingId: 'UA-11066411-23', // Betelgeuse Staging (UA)
    gaTrackingDomain: 'hu-staging.be',
    ga4TrackingId: 'G-8KMT47NK58', // G4 Betelgeuse Staging (GA4), _ga_8KMT47NK58 cookie in cookieControl.js
    COOKIE_CONTROL_API_KEY: 'a8f76ffb6fddeedd010a170c4069c28c297c2f01',
  },
  'production': {
    AURORA_API_PATH: isServer ? 'http://hu-nginx-internal.production.hu-internal.be/api/' : 'https://healthunlocked.com/api/',
    REDIRECT_PROXY: 'https://healthunlocked.com/',
    SOLARIS_API_PATH: isServer ? 'http://hu-nginx-internal.production.hu-internal.be/' : 'https://healthunlocked.com/',
    SOLARIS_API_PUBLIC_PATH: isServer ? 'http://solaris-api.production.hu-internal.be/' : 'https://solaris.healthunlocked.com/',
    DISCOVER_API_PATH: 'https://discover-api.hu-production.be/',
    DISCOVER_API_KEY: 'API-KEY [v4HVwTUCcccowGpcJqTddQsC3+/3BTs',
    WS_URL: 'wss://healthunlocked.com/',
    IMG_PATH: 'https://images.hu-production.be',
    CDN_PATH: 'https://assets.hu-production.be',
    ASSET_PREFIX_PATH: 'https://assets.hu-production.be/solaris',
    environment: 'production',
    gaTrackingId: 'UA-11066411-1', // Betelgeuse (UA)
    gaTrackingDomain: 'healthunlocked.com',
    ga4TrackingId: 'G-PWYN7K2H5K', // G4 Betelgeuse (GA4), _ga_PWYN7K2H5K cookie in cookieControl.js
    COOKIE_CONTROL_API_KEY: '21ad29290cdd60a97ce05df1864167a9764044e4',
  },
};
